
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HomeView',
  components: {
  },
  methods: {
    loadFile (track: number) {
      console.log(track)
    }
  }
})
